<template>
  <div ref="ticketList" class="ticket-list">
    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'TicketList'
  }
</script>
